export default "__VITE_PUBLIC_ASSET__2b446417__"